// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"App_pageContent__4PlPs"};